import { render, staticRenderFns } from "./ViewDocumentsTypes.vue?vue&type=template&id=62e65662&scoped=true"
import script from "./ViewDocumentsTypes.vue?vue&type=script&lang=js"
export * from "./ViewDocumentsTypes.vue?vue&type=script&lang=js"
import style0 from "./ViewDocumentsTypes.vue?vue&type=style&index=0&id=62e65662&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e65662",
  null
  
)

export default component.exports